/**
 * @param {Array<Object>} flags - product flags
 * @param {string} containerClass - container class
 * @returns {string} product flags HTML
 */
export default (flags, containerClass) => `
${
    flags && flags.length > 0
        ? `
        <div class="product-tile-flag flag-${containerClass}">
            <div class="product-flag ${flags.length === 1 ? 'flag1only' : 'flag1and2'}">
                ${flags
                    .map(
                        (flag, index) => `
                        <div class="product-flag-item flag-${index + 1} ${flag.type} ${flag.additionalClass || ''}">
                            ${
                                flag.text
                                    ? `<span>${flag.text}</span>`
                                    : `<img alt="${flag.type}" src="${flag.img}" width="66" height="23">`
                            }
                        </div>
                        `
                    )
                    .join('')}
            </div>
        </div>`
        : ''
}
`;
